/** The buyer forms' requirements are Identity's contracts package's
 *  (`@libs/identity-onboarding-contracts/requirements`): this package
 *  re-exports them for its clients. */
export * from "@libs/identity-onboarding-contracts/requirements";
